class FormattersVuePlugin {
  static install (Vue) {
    Vue.mixin({
      filters: {
        fixedLength: function (value, maxLength) {
          if (!value) {
            return ''
          }

          if (value.length > maxLength) {
            return value.slice(0, maxLength - 3) + '...'
          } else {
            return value
          }
        },

        rounded: function (value, decimalPlaces = 2) {
          return Math.round(parseFloat(value) * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces)
        },
        formatPrice: function (value) {
          if (!value) return '0.00'
          value = value.toString()
          if (!value.includes('.')) return value
          let trimmedAmount = 2 - value.toString().split('.')[1].length
          trimmedAmount = trimmedAmount >= 0 ? trimmedAmount : 0
          return value.toString() + '0'.repeat(trimmedAmount)
        }
      }
    })
  }
}
export default FormattersVuePlugin



// WEBPACK FOOTER //
// ./src/ui/FormattersVuePlugin.js